<template>
  <section class="dialog-container">
    <header class="dialog-header">
      <span>{{ title }}</span>
      <!--      <close-button @click="$modal.hideAll()"></close-button>-->
    </header>
    <main class="dialog-main">
      <input
        type="text"
        ref="input"
        name="value"
        :value="form.value"
        @input="handleInput"
        @keypress="saveOnEnter"
        required
        autocomplete="off"
      />
    </main>
    <footer class="dialog-footer">
      <button class="pill-button secondary" @click="$emit('close')">
        Annuleren
      </button>
      <button
        type="submit"
        class="pill-button"
        :disabled="v$.form.$invalid || !v$.form.$dirty"
        @click="save()"
      >
        {{ actionLabel }}
      </button>
    </footer>
  </section>
</template>

<script>
import { required, minLength } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'

export default {
  props: ['name', 'title', 'actionLabel', 'callback'],
  name: 'NameDialog',
  setup() {
    return { v$: useVuelidate() }
  },
  mounted() {
    this.$refs.input.focus()
  },
  data() {
    return {
      form: {
        value: this.name
      }
    }
  },
  validations: {
    form: {
      value: {
        minLength: minLength(1),
        required
      }
    }
  },
  methods: {
    saveOnEnter(event) {
      if (event.key === 'Enter') this.save()
    },
    save() {
      this.callback(this.form.value)
      this.$emit('close')
    },
    handleInput(event) {
      this.form.value = event.target.value
      this.v$.$touch()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
  padding: 25px;

  .dialog-header {
    padding: 0;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
  }

  .dialog-main {
    margin-bottom: 10px;

    input {
      width: 100%;
    }
  }

  .dialog-footer {
    padding: 0;
    display: flex;
    justify-content: flex-end;

    button {
      margin-left: 10px;
    }
  }
}
</style>
